var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 13,
    viewBox: "0 0 16 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.500061 3L5.04166 6.02775C6.11085 6.7405 6.64548 7.09692 7.22323 7.23542C7.73389 7.35775 8.26623 7.35775 8.77689 7.23542C9.35464 7.09692 9.88931 6.7405 10.9585 6.02775L15.5001 3M3.16673 12.1667H12.8334C13.7668 12.1667 14.2336 12.1667 14.5901 11.985C14.9036 11.8253 15.1586 11.5703 15.3184 11.2567C15.5001 10.9002 15.5001 10.4334 15.5001 9.5V3.16667C15.5001 2.23325 15.5001 1.76653 15.3184 1.41002C15.1586 1.09641 14.9036 0.841442 14.5901 0.681658C14.2336 0.5 13.7668 0.5 12.8334 0.5H3.16673C2.23331 0.5 1.76659 0.5 1.41008 0.681658C1.09647 0.841442 0.841503 1.09641 0.681719 1.41002C0.500061 1.76653 0.500061 2.23324 0.500061 3.16667V9.5C0.500061 10.4334 0.500061 10.9002 0.681719 11.2567C0.841503 11.5703 1.09647 11.8253 1.41008 11.985C1.76659 12.1667 2.2333 12.1667 3.16673 12.1667Z",
    stroke: "#171C21",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.280b282a83b713b234ad537f982be5bf.svg";
export { ForwardRef as ReactComponent };